import React, { PureComponent } from "react";
import { Search } from "baseui/icon";
import { Input, SIZE } from "baseui/input";
import RangeInput from "./RangeInput";
import DeleteIcon from "baseui/icon/delete";

export default class Filter extends PureComponent {
  constructor(props) {
    super(props);
    this.monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ];

    this.state = { inputDisabled: false };
    this.textInput = React.createRef();
  }

  componentWillUnmount() {
    cancelAnimationFrame(this._animationFrame);
  }

  _formatDate(t) {
    const date = new Date(t * this.props.MS_PER_DAY);

    return `${
      this.monthNames[date.getMonth()]
    } ${date.getDate()}, ${date.getUTCFullYear()}`;
  }

  _formatLabel(t) {
    const date = new Date(t * this.props.MS_PER_DAY);
    return `${date.getUTCMonth() + 1}/${date
      .getFullYear()
      .toString()
      .substr(-2)}`;
  }

  _handleClearSearch() {
    this.setState({ inputDisabled: false });
    this.textInput.current.focus();
    this.props.onClearSearch();
  }

  _renderResults(results) {
    let listItems = [];
    for (let index = 0; index < results.length; index++) {
      const element = results[index];
      listItems.push(
        <li
          className="li-result"
          key={index}
          tabindex={index}
          role="button"
          aria-label={`Click here to select ${element.place_name}`}
          onClick={e => this._handleClick(e, element)}
        >
          {element.place_name}
        </li>
      );
    }
    return <ul className="results">{listItems}</ul>;
  }

  _handleClick(e, item) {
    this.setState({ inputDisabled: true });
    this.props.onSearchSelect({ item });
  }

  render() {
    const {
      filterValue,
      timeRange,
      triggerAnimation,
      totalBlackouts,
      totalAffected,
      onSearchChange,
      onFilterChange,
      searchResults,
      searchTerm
    } = this.props;
    const { inputDisabled } = this.state;
    return (
      <div className="filter-container">
        <div className="grid-container">
          <div className="heading">
            <div className="title">
              <h1>Power Outage Map</h1>
            </div>
          </div>
          <div className="search">
            <Input
              tabindex={-1}
              disabled={inputDisabled}
              endEnhancer={<Search size="25px" color="#E5E5E5" />}
              onChange={onSearchChange}
              inputRef={this.textInput}
              size={SIZE.compact}
              {...(searchTerm && { value: "" })}
              {...(!searchTerm && { placeholder: "City name" })}
              overrides={{
                Input: {
                  style: ({ $theme }) => {
                    return {
                      backgroundColor: "white"
                    };
                  }
                }
              }}
            />
            {searchTerm && (
              <a
                onClick={this._handleClearSearch.bind(this)}
                className="search-term"
                href="#search"
              >
                {searchTerm}
                <DeleteIcon className="x-icon" />
              </a>
            )}
            {searchResults && this._renderResults(searchResults)}
          </div>
          <div className="slider">
            {triggerAnimation && timeRange && (
              <RangeInput
                min={timeRange[0]}
                max={timeRange[1]}
                value={filterValue}
                delay={1000}
                formatLabel={this._formatLabel.bind(this)}
                onChange={onFilterChange}
              />
            )}
          </div>
          <div className="dates-copy">
            <p>Selected dates</p>
            <p className="dates">
              {this._formatDate(filterValue[0])} -{" "}
              {this._formatDate(filterValue[1])}
            </p>
          </div>
          <div className="tally">
            <div className="total-blackouts-count">
              <h3 className="total-count">{totalBlackouts.toLocaleString()}</h3>
            </div>
            <div className="total-customers">
              <h3 className="total-count">{totalAffected.toLocaleString()}</h3>
            </div>
            <div className="total-blackouts-title">
              <h2>Total blackouts</h2>
            </div>
            <div className="total-customers-title">
              <h2>Customers impacted</h2>
            </div>
          </div>
          <div className="logo-container">
              <a href="https://www.bloomenergy.com/" target="_blank" rel="noopener noreferrer">Bloomenergy®</a>
          </div>
        </div>
      </div>
    );
  }
}
